import { render, staticRenderFns } from "./BaseTableInstallmentKTC.vue?vue&type=template&id=40842320&scoped=true&"
import script from "./BaseTableInstallmentKTC.vue?vue&type=script&lang=js&"
export * from "./BaseTableInstallmentKTC.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableInstallmentKTC.vue?vue&type=style&index=0&id=40842320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40842320",
  null
  
)

export default component.exports